export default "__VITE_ASSET__CuK1AGRn__"